"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgLpg16 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 .5h16v16H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M6 4.953v-1.75h4v1.75m0 8.358v1H6v-1M5 4.953h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1ZM9.344 9.69a1.383 1.383 0 0 1-1.322 1.135c-.617.025-1.165-.336-1.336-.873-.146-.46-.03-.964.351-1.542.05-.076.163-.214.262-.334l.016.062c.043.148.1.291.218.339.072.029.187.03.316-.128.278-.343.408-.805.357-1.272.868.794 1.293 1.768 1.138 2.613Z", stroke: "currentColor" })] })) }))); };
exports.default = SvgLpg16;
